export default __webpack_public_path__ + "static/media/scroll.ba90cc15.png";